import React, { useEffect, useState } from "react";
import FixedSelectInput from "../../input/fixed-select-input";
import SyncProblemIcon from "@mui/icons-material/SyncProblem";
import { useComponentBackgroundColor } from "../../common/adaptive-theme-provider";
import { Typography } from "@mhome/ui";

const SelectDetail1Widget = ({ widget, onValueUpdate, pattern }) => {
  const [v0, setV0] = useState(null);
  const getComponentBgColor = useComponentBackgroundColor();

  useEffect(() => {
    setV0(widget);
    return () => {};
  }, [widget]);

  const handleValueUpdate = (data) => {
    const updatedWidget = { ...v0, value: data };
    onValueUpdate(updatedWidget);
  };

  const disabled = pattern && pattern.endsWith("_R");
  const showWarning = pattern && pattern.endsWith("_W");

  return (
    <div className="w-full flex flex-col">
      {/* Select Controls Section */}
      <div
        className="flex flex-col rounded-2xl"
        style={{
          padding: "12px",
          backgroundColor: getComponentBgColor("hsl(var(--card))"),
        }}
      >
        <Typography className="mb-3 font-bold flex items-center gap-1 text-sm">
          {v0?.description ? v0.description : "Select"}
          {showWarning && (
            <SyncProblemIcon
              fontSize="inherit"
              style={{ color: "hsl(var(--warning))" }}
            />
          )}
        </Typography>

        <div className="flex items-center h-full w-full">
          {v0 && (
            <FixedSelectInput
              valueSpec={v0}
              onChange={handleValueUpdate}
              onError={() => {}}
              multiSelect={false}
              zIndex="var(--z-index-automation-input)"
              disabled={disabled}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SelectDetail1Widget;
